var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-item-title"},[_c('search-item-info',{attrs:{"info":_vm.item,"mode":_vm.mode}}),_c('search-item-box',{attrs:{"placeholder":_vm.placeholder},on:{"search":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }